import { Grupo, ISgrupo } from "../grupo/Grupo";
import { Setor } from "../setor/Setor";
import { IStipoDocumento, TipoDocumento } from "../tipoDocumento/TipoDocumento";
import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { Usuario } from "../usuario/Usuario";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { ISprocesso, Processo } from "./Processo";

export interface Acompanhamento {
    id: string;
    processo: Processo;
    grupoAcompanhamento: Grupo | null;
    descricao: string;
    usuario: UsuarioList;
    processoId: "",
    dataHoraCriacao: Date | null;
}

export const ISacompanhamento: Acompanhamento = {
    id: "",
    processoId: "",
    grupoAcompanhamento: null,
    descricao: "",
    usuario: ISusuarioList,
    processo: ISprocesso,
    dataHoraCriacao: null,

}

